module.exports = __webpack_public_path__ + "img/img-carousel1.de6d5e6e.jpg";